<template>
	<section class="why-us-section section">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-lg-10 col-lg-offset-1">
					<div class="content-wrapper">
						<div class="image-wrapper">
							<basePicture :image="item.image"
										 sizes="xs:100vw md:100vw lg:33vw xl:33vw 2xl:33vw 3xl:33vw"
										 loading="eager" />
						</div>
						<div class="text-wrapper">
							<div>
								<h3 class="title">
									{{ item.title }}
								</h3>
								<baseRichText :data="item.text" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
})

const item = computed(() => props.data?.item)
</script>

<style lang="scss" scoped>
.title {
	@include textH5;
}

.why-us-section {
	background-color: #121212;
	color: #fdfdfd;
	padding: rem-calc(80 0);

	.content-wrapper {
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
		gap: $gutter-width;

		@include for-devices-above(md) {
			flex-flow: row nowrap;
		}

		@include for-devices-above(lg) {
			gap: rem-calc(80);
		}

		.image-wrapper {
			flex-grow: 1;
			flex-shrink: 1;
			flex-basis: 0px;
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;

			img {
				display: block;
				max-width: 100%;
				height: auto;
				max-height: 50vh;
				border-radius: rem-calc(20);
			}
		}

		.text-wrapper {
			flex-grow: 2;
			flex-shrink: 1;
			flex-basis: 0px;
			display: flex;
			flex-flow: column nowrap;
			justify-content: center;
			height: 100%;
		}
	}
}

:deep(picture) {
	border-radius: rem-calc(20);
	overflow: hidden;
}
</style>